<script setup lang="ts">
// Tela de sucesso do saque (ENG-868). Saída do fluxo, sem stepper.

type Emits = {
  close: [];
};

const emit = defineEmits<Emits>();

const { closeModal } = useLayoutStore();
// Minha Conta V2 é um painel de estado PRÓPRIO (useUserV2Modal), fora do
// layout store: o closeModal() acima não o alcança.
const { close: closeUserV2Modal } = useUserV2Modal();

// "Jogar novamente" precisa levar a algum lugar: a tela antiga
// (Info/CashoutSuccess.vue) redirecionava pra home, e só fechar o sheet deixa
// o usuário parado na carteira, com cara de clique sem efeito. Com a copy nova
// o destino é o catálogo de jogos.
function playAgain() {
  emit('close');
  closeModal();
  // Nada fecha o painel Minha Conta numa navegação pra FORA de /user/*: as
  // rotas /user/* são interceptadas pelo middleware userV2Modal e viram troca
  // de tela, as outras passam direto e deixam o painel por cima do destino.
  // Quem sai do painel fecha na mão — mesma regra do user-v2/Shortcuts.vue.
  closeUserV2Modal();

  navigateTo(localeLink('/games/category/all'));
}

// O Figma tem só o JOGAR NOVAMENTE, mas o extrato era um caminho que a tela
// antiga (Info/CashoutSuccess.vue) oferecia — tirá-lo por omissão no desenho
// seria regressão, então ele fica como link secundário (SPEC §6.5).
function goToTransactions() {
  emit('close');
  closeModal();

  navigateTo(localeLink('/user/wallet/transactions?select=user-wallet'));
}
</script>

<template>
  <section class="wdm-success">
    <div class="wdm-success-row">
      <img
        alt=""
        aria-hidden="true"
        class="wdm-success-art"
        :src="getAssetsUrlForCDN('/assets/images/svg/withdraw.svg')"
      />

      <div class="wdm-success-text">
        <p class="wdm-success-title">
          {{ $t('account.wallet.withdraw_modal.success_message_title') }}
        </p>
        <p class="wdm-success-subtitle">
          {{ $t('account.wallet.withdraw_modal.success_message_subtitle') }}
        </p>
      </div>
    </div>

    <button
      class="wdm-success-cta"
      type="button"
      @click="playAgain"
    >
      {{ $t('account.wallet.withdraw_modal.play_again') }}
    </button>

    <button
      class="wdm-success-link"
      type="button"
      @click="goToTransactions"
    >
      {{
        $t('account.wallet.withdraw_modal.cashout_success.transactions_history')
      }}
    </button>
  </section>
</template>

<style scoped lang="scss">
.wdm-success {
  display: flex;
  flex-direction: column;
  gap: 14px;
  width: 100%;
  font-family: 'Plus Jakarta Sans', sans-serif;
}

.wdm-success-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

// Arte provisória: o Figma usa um cifrão 3D que ainda não existe no projeto
// (SPEC 8.4). Até o design entregá-lo, o ícone de saque do fluxo antigo faz o
// papel, com a flutuação leve que o card pede ("ícone animado").
//
// `animation`, não `transition`: o reset global de main.scss mata transition
// no app inteiro.
.wdm-success-art {
  width: 96px;
  height: 96px;
  flex-shrink: 0;
  animation: wdm-float 2.4s ease-in-out infinite;
}

@keyframes wdm-float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-6px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .wdm-success-art {
    animation: none;
  }
}

.wdm-success-text {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.wdm-success-title {
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
}

.wdm-success-subtitle {
  color: #a9adb8;
  font-size: 12px;
  line-height: 16px;
}

.wdm-success-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border-radius: 8px;
  background: #ff3700;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}

.wdm-success-link {
  align-self: center;
  color: #38bdf8;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
